import { useState, useEffect } from 'react';
import { SideSlider, Spin } from '@wajeez-web/components/ui';
import { PageHeader } from '@wajeez-web/components/layouts';
import { Button, TextInput, NoData } from '@wajeez-web/components/ui';
import { SearchIcon } from '@heroicons/react/outline';
import { FiEdit } from 'react-icons/fi';
import bg from '../../../../../shared-assets/images/bg.jpg';
import EditUserForm from '../components/EditUserForm';
import UserViewDetails from '../components/UserViewDetails';
import { RefreshIcon } from '@heroicons/react/outline';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { useCommonDispatch } from '@wajeez-web/stores/common';
import { useNavigate } from 'react-router-dom';
import { HasPermissionWrapperComponent } from '@wajeez-web/components/helpers';
import {
  useCustomerSelector,
  CustomerCareActions,
  searchUsersByFilter,
  getFcmTokenByUserId,
} from '@wajeez-web/stores/customers';

const userSliderInitState = { show: false, selectedUserId: null, index: -1 };

const CustomerCarePage = () => {
  const {
    details,
    userPoints,
    userPlans,
    fcmTokenByUserId,
    searchUsersByFilter: searchUsersByFilterState,
  } = useCustomerSelector((s) => s.customerCare);
  const navigate = useNavigate();
  const dispatch = useCommonDispatch();
  const [userSliderstate, setUserSliderState] = useState<{
    show: boolean;
    selectedUserId: string | null;
    index: number;
  }>(userSliderInitState);
  const [searchInputvalue, setSearchInputValue] = useState('');

  const [editUser, setEditUser] = useState(false);
  const [isSearching, setIsSearching] = useState(false);

  const searchByFilter = () => {
    searchUsersByFilter(searchInputvalue);
  };

  useEffect(() => {
    setEditUser(false);
    getSelectedUserData();
  }, [userSliderstate.selectedUserId]);

  const getSelectedUserData = () => {
    if (userSliderstate.selectedUserId) {
      dispatch(
        CustomerCareActions.getUserByIdAsync(userSliderstate.selectedUserId)
      );

      getFcmTokenByUserId(userSliderstate.selectedUserId);

      dispatch(
        CustomerCareActions.getUserPointsAsync(
          userSliderstate.selectedUserId || ''
        )
      );
      dispatch(
        CustomerCareActions.getUserPlansAsync(
          userSliderstate.selectedUserId || ''
        )
      );
    }
  };

  const getSelectedUserByIdData = () => {
    if (
      !searchUsersByFilterState.data.find(
        (item) => item.id === userSliderstate.selectedUserId
      ) &&
      details
    ) {
      return (
        <div
          key={details.id}
          onClick={() => {
            setUserSliderState({
              show: true,
              selectedUserId: details.id || null,
              index: 0,
            });
          }}
          className={`px-10 py-4 flex w-full space-s-2  ${
            userSliderstate.selectedUserId === details.id
              ? 'bg-gray-100'
              : 'bg-white'
          } hover:bg-gray-100 cursor-pointer`}
        >
          <div className=" rounded-full h-10 w-10 bg-ring-color text-center p-1.5 align-middle text-lg uppercase font-semibold ">
            {details.name?.trim()[0] || details.email?.trim()[0]}
          </div>
          <div className="flex flex-col ">
            <div>{details.name}</div>
            <div className=" text-textSecondary ">{details.email}</div>
          </div>
        </div>
      );
    }
    return null;
  };

  const updateData = () => {
    if (searchUsersByFilterState.data.length > 0) {
      searchByFilter();
    }

    if (userSliderstate.selectedUserId) {
      getSelectedUserData();
    }
  };

  useEffect(() => {
    return () => {
      dispatch(CustomerCareActions.clear());
    };
  }, []);

  const onDeleteUser = async () => {
    if (userSliderstate.selectedUserId) {
      const res = await dispatch(
        CustomerCareActions.deleteUserAsync(userSliderstate.selectedUserId)
      );
      if (res.meta.requestStatus === 'fulfilled') {
        searchByFilter();
        setUserSliderState({
          ...userSliderstate,
          selectedUserId:
            userSliderstate.index === 0
              ? searchUsersByFilterState.data[1].id || null
              : searchUsersByFilterState.data[userSliderstate.index - 1].id ||
                null,
          index: userSliderstate.index === 0 ? 0 : userSliderstate.index - 1,
        });
      }
    }
  };
  return (
    <div className="overflow-y-hidden  h-inner-screen flex flex-row w-full">
      <div className=" w-1/5 h-full flex flex-grow flex-col overflow-y-scroll scrollbar-thin scrollbar-thumb-gray-500 scroll">
        <PageHeader
          title={'Customer Care'}
          breadCrumbsLinks={[{ title: 'customer-care' }]}
          bottomSidecomponent={
            <div
              className={`flex align-middle items-center  w-full ${
                userSliderstate.show
                  ? 'flex-col justify-center  space-y-2'
                  : 'flex-row space-s-2'
              }`}
            >
              <div className="w-[400px] flex space-s-2">
                <div className="w-full">
                  <TextInput
                    onClick={(e) => {
                      if (e.keyCode === 13) {
                        searchByFilter();
                      }
                    }}
                    shape="circle"
                    suffix={
                      isSearching ? (
                        <RefreshIcon className="animate-spin h-5 w-5" />
                      ) : (
                        <></>
                      )
                    }
                    value={searchInputvalue}
                    onChange={(name, value) => setSearchInputValue(value)}
                    name="searchInput"
                    placeholder="Search User"
                    prefix={<SearchIcon className="w-4 me-2" />}
                  />
                </div>
                <Button
                  disabled={searchInputvalue.length ? false : true}
                  shape="circle"
                  title={'Search'}
                  onClick={searchByFilter}
                />
              </div>
            </div>
          }
        />
        {getSelectedUserByIdData()}
        {searchUsersByFilterState.data?.length &&
        searchUsersByFilterState.status !== 'loading' ? (
          <div className=" divide-y ">
            <div className="  font-medium px-10 py-1 ">
              <ReturnTranslatedText
                origintext="Searched Users"
                text={`general.${'Searched Users'}`}
              />
            </div>
            {searchUsersByFilterState.data?.map((item, i) => (
              <div
                key={item.id || i}
                onClick={() => {
                  setUserSliderState({
                    show: true,
                    selectedUserId: item.id || null,
                    index: i,
                  });
                }}
                className={`px-10 py-4 flex w-full space-s-2  ${
                  userSliderstate.selectedUserId === item.id
                    ? 'bg-gray-100'
                    : 'bg-white'
                } hover:bg-gray-100 cursor-pointer`}
              >
                <div className=" rounded-full h-10 w-10 bg-ring-color text-center p-1.5 align-middle text-lg uppercase font-semibold ">
                  {item.name?.trim()[0] || item.email?.trim()[0]}
                </div>
                <div className="flex flex-col ">
                  <div>{item.name}</div>
                  <div className=" text-textSecondary ">{item.email}</div>
                </div>
              </div>
            ))}
          </div>
        ) : searchUsersByFilterState.status !== 'loading' ? (
          <div className="my-auto h-auto flex-grow  flex flex-col align-middle">
            <NoData />
          </div>
        ) : (
          <div className="w-full h-[500px] flex justify-center items-center">
            <Spin />
          </div>
        )}
      </div>
      {userSliderstate.show && (
        <div className="w-4/5 border-s overflow-y-auto  scrollbar-thin scrollbar-thumb-gray-500 bg-white">
          <SideSlider
            title=""
            width="full"
            show={userSliderstate.show}
            close={() => {
              setUserSliderState(userSliderInitState);
            }}
            closeButtonColor="white"
            header={
              <>
                <div className=" w-full  h-44 ">
                  <img
                    alt=""
                    className="absolute inset-0 object-cover w-full h-full "
                    src={bg}
                  />
                </div>
                <div className="flex  justify-start relative ">
                  <div
                    className={` -top-16 absolute rounded-full h-32 rtl:right-4 ltr:left-4 w-32 bg-primary-50 flex align-middle p-6 justify-center text-7xl uppercase`}
                  >
                    {' '}
                    <div className="h-full flex  justify-center overflow-clip align-middle">
                      {details?.name?.trim()[0] || details?.email?.trim()[0]}
                    </div>
                  </div>
                </div>
              </>
            }
          >
            <div className="h-full w-full z-50">
              <div className="flex justify-end pt-8 space-s-2  px-8">
                {!editUser && (
                  <Button
                    shape="circle"
                    onClick={() => {
                      setEditUser(true);
                    }}
                    title="Edit"
                    Icon={FiEdit}
                  />
                )}
                {!editUser && (
                  <HasPermissionWrapperComponent
                    permissions={['120.2', '120.0', '120.1', '122.1', '121.1']}
                  >
                    <Button
                      shape="circle"
                      onClick={() => {
                        navigate(`/wajeez-customers/${details?.id}/analytics`);
                      }}
                      title="Analytics"
                      // Icon={FiEdit}
                    />
                  </HasPermissionWrapperComponent>
                )}
              </div>
              {userSliderstate.selectedUserId &&
                (editUser ? (
                  <EditUserForm
                    onDeleteUser={onDeleteUser}
                    setEditUserState={setEditUser}
                    data={details || {}}
                    points={userPoints}
                    getData={updateData}
                  />
                ) : (
                  <UserViewDetails
                    userPlan={userPlans ? userPlans[0] : undefined}
                    data={details || {}}
                    fcmToken={fcmTokenByUserId.data?.token}
                    points={userPoints}
                  />
                ))}
            </div>
          </SideSlider>
        </div>
      )}
    </div>
  );
};

export default CustomerCarePage;
